import { IconComponentsProps } from './types';

const NoResultsIcon = ({ fill = 'black', ...props }: IconComponentsProps) => (
  <svg width="144" height="144" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M135 15.3633L33.3633 117H126V45H135V117C134.997 119.386 134.049 121.674 132.361 123.361C130.674 125.049 128.386 125.997 126 126H24.3633L15.3633 135L9 128.637L110.637 27H18V99H9V27C9.00274 24.6139 9.95144 22.3259 11.6387 20.6387C13.3259 18.9514 15.6139 18.0027 18 18H119.637L128.637 9L135 15.3633ZM45 81H27V72H45V81ZM63 63H27V54H63V63ZM72 45H27V36H72V45Z"
      fill={fill}
      fillOpacity="0.55"
    />
  </svg>
);

export default NoResultsIcon;
